import { mapState } from 'vuex'
import { config } from '../config'

const { stepsList } = config
export default {
  data() {
    return {
      stepsList,
    }
  },
  computed: {
    ...mapState({
      auditDetail: (state) => state.approve.auditDetail,
      accountList: (state) => state.approve.accountList,
      templateDetail: (state) => state.approve.templateDetail,
    }),
  },
}
